import React from 'react';
import { Container } from 'react-bootstrap';

//  Styles
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
	return (
		<>
			<section className="title">
				<Container className="py-4">
					<h1>Privacy Policy</h1>
				</Container>
			</section>
			<section className="atualizacao">
				<Container>
					<p className="text-muted">
						<b>Last Update: </b>16/12/2021
					</p>
				</Container>
			</section>
			<section className="artigo">
				<Container>
					<section className="intro">
						<h3 className="text-uppercase">Introdução</h3>
						<p>
							FSDev respects the privacy of its visitors. This
							Privacy Policy explains how I collect, use,
							disclose, and safeguard your information when you
							visit my website francisco-silva.netlify.app. Please
							read the privacy policy carefully. If you do not
							agree with the terms of this privacy policy, please
							do not access the site.
						</p>
						<p>
							I reserve the right to make changes to this privacy
							policy at any time for any reason. I will notify you
							of any changes by updating the "Last Update" date of
							this Privacy Policy. Any change or modification will
							be effective immediately upon posting the updated
							Privacy Policy on this site.
						</p>
						<p>
							I recommend that you periodically review this
							Privacy Policy to stay informed. To keep yourself
							informed, you will be subject to and accept the
							changes in any Privacy Policy revised by your
							continued use of the Site after the date of posting
							of the revised Privacy Policy.
						</p>
					</section>
					<br />
					<section className="recolha">
						<h3 className="text-uppercase">
							Collecting your information
						</h3>
						<p>
							I may collect information about you in a variety of
							ways. The information that we may collect on the
							site includes:
						</p>
						<h5>Personal Data</h5>
						<p>
							Personally identifiable information, such as your
							name and e-mail address, which you voluntarily when
							you fill out the form to contact me. You are under
							no obligation to provide personal information of any
							kind, however, your refusal to do may prevent you
							from using certain features of the site.
						</p>
						<h5>Derived Data</h5>
						<p>
							Information that my servers collect automatically
							when you access the site, such as your IP address,
							browser type, operating system access times and the
							pages that you viewed directly before and after you
							access the site.
						</p>
						<h5>Mobile Device Data</h5>
						<p>
							Device information, such as your mobile device ID,
							model and manufacturer, and information about the
							location of your device, if you accessed the site
							from a mobile device.
						</p>
						<h5>Third Party Data</h5>
						<p>
							Information from third parties, such as personal
							information or friends on the network, connect your
							account to third parties and granting permission to
							the site to access to that information.
						</p>
					</section>
					<br />
					<section className="uso">
						<h3 className="text-uppercase">
							Usage of your information
						</h3>
						<p>
							Having accurate information about you allows us to
							to offer a smooth, efficient, and personalized
							experience. Specifically, we may use the information
							collected about you through the site to:
						</p>
						<ul>
							<li>
								Assist law enforcement and respond to subpoena.
							</li>
							<li>
								Compile anonymous statistical data and analyses
								for internal use or with third parties.
							</li>
							<li>
								Provide targeted advertising, newsletters and
								other information about the site for you.
							</li>
							<li>
								Increase the efficiency and operation of the
								site.
							</li>
							<li>
								Monitor and analyze usage and trends to improve
								your experience with the site.
							</li>
							<li>Notifying you about site updates.</li>
							<li>
								Perform other business activities as needed.
								required.
							</li>
							<li>
								Prevent fraudulent transactions, monitor against
								theft and protect against criminal activities.
							</li>
							<li>
								Requesting feedback and contacting you about the
								use of the site.
							</li>
							<li>Resolve disputes and solve problems.</li>
							<li>
								Respond to requests for products and services to
								the customer.
							</li>
							<li>Send you a newsletter.</li>
							<li>Request support for the site.</li>
						</ul>
					</section>
					<br />
					<section className="divulgacao">
						<h3 className="text-uppercase">
							DISCLOSURE OF YOUR INFORMATION
						</h3>
						<p>
							I may share information I have collected about you
							in certain situations. Your information may be
							disclosed in the following ways:
						</p>
						<h5>By Law or to Protect Rights</h5>
						<p>
							If you believe that disclosure of information about
							you is necessary to respond to a legal process, to
							investigate or remedy possible violations of my
							policies, or to protect the rights property and
							safety of others, I may share your information as
							permitted or required by any applicable law, rule or
							regulation. This includes exchanging information
							with other entities for fraud protection and credit
							risk reduction.
						</p>
						<h5>Third-Party Service Providers</h5>
						<p>
							I may share your information with third parties who
							provide services for me or on my behalf, including
							data analysis, email delivery and customer service.
						</p>
						<h5>Marketing Communications</h5>
						<p>
							With your consent, or with the opportunity to
							withdraw consent, I may share your information with
							third parties for marketing purposes as permitted by
							law.
						</p>
						<h5>Testimonials</h5>
						<p>
							I may use your personal information, including name,
							occupation and photograph, when authorizing the
							publication of the testimonial you have written
							about the service provided.
						</p>
						<h5>Third-Party Advertisers</h5>
						<p>
							I may use third-party advertising companies to serve
							ads when you visit the site. These companies may use
							information about your visits to the site and other
							sites that are contained in web cookies to serve ads
							about products and services of interest to you.
						</p>
						<h5>Business Partners</h5>
						<p>
							I may share your information with our business
							partners to offer you certain products or services
							to you.
						</p>
						<h5>Other Third-Parties</h5>
						<p>
							I may share your information with advertisers and
							investors for the purpose of conducting general
							business analysis. I may also share your information
							with third parties for marketing purposes as
							permitted by law.
						</p>
					</section>
					<br />
					<section className="rastreamento">
						<h3 className="text-uppercase">
							Tracking Technologies
						</h3>
						<h5>Cookies e Web Beacons</h5>
						<p>
							I may use cookies, web beacons, tracking pixels and
							other tracking technologies on the to help
							personalize the site and enhance your experience.
							When you access the site, your personal information
							is not collected through the use of tracking
							technology. Most browsers are set to accept cookies
							by default. You can remove or reject cookies, but be
							aware that doing so may affect the availability and
							functionality of the site. You cannot refuse web
							beacons. However, they may be ineffective by
							declining all cookies or by modifying your web
							browser settings to notify you each time a cookie is
							offered, allowing you to accept or reject cookies
							individually.
						</p>
						<p>
							I may use cookies, web beacons, tracking pixels
							tracking pixels and other tracking technologies on
							the to help personalize the site and enhance your
							experience. For more information on how I use
							cookies, please see the Cookie Policy posted on the
							site, which is incorporated into this Privacy
							Policy. By using the site, you agree to abide by my
							Cookie Policy.
						</p>
						<h5>Website Analytics</h5>
						<p>
							I may also partner with third-party vendors to
							enable tracking technologies and remarketing
							services on the site through the use of first-party
							cookies and third-party cookies, to, among other
							things, analyze and track users' use of the site,
							determine the popularity of certain content and to
							better understand online activity online. By
							accessing the site, you agree to the collection and
							use of your information by these third party
							vendors. I recommend that you review their privacy
							policy and contact them directly with them to get
							answers to your questions. I do not transfer
							personal information to these third-party vendors.
							However, if you do not want any information
							collected and used by tracking technologies, you can
							visit the third party vendor or the opt-out tool of
							the Advertising Initiative or the Digital
							Advertising Alliance Opt-Out Tool.
						</p>
						<p>
							You should be aware that you get a new computer,
							installing a new browser, updating an existing
							browser, or deleting or otherwise altering your
							browser's cookie files may also clear certain
							cancellation cookies, plug-ins, or settings.
						</p>
						<h5>Third-Party Websites</h5>
						<p>
							The site may contain links to third-party websites
							and applications of interest, including
							advertisements and services, which are not
							affiliated with me. Once you have used these links
							to leave the site any information that you provide
							to these third parties will not be covered by this
							Privacy Policy, and I cannot guarantee the security
							and privacy of your information. Before you visit
							and provide any information to any third party
							sites, you should inform yourself about the privacy
							policies and practices policies and practices (if
							any) of the third party responsible that site, and
							you should take steps to, at your own discretion, to
							protect the privacy of your information. I am not
							responsible for the content or privacy and security
							practices and policies of third parties, including
							other sites, services or applications that may be
							linked to or from the site.
						</p>
					</section>
					<br />
					<section className="seguranca">
						<h3 className="text-uppercase">
							Your Information Security
						</h3>
						<p>
							I use administrative, technical and physical
							security measures to help protect your personal
							information. Although we have taken reasonable steps
							to protect the personal information that you provide
							to us, please be aware that despite my efforts, no
							security measures are perfect or impenetrable and no
							method of data transmission can be guaranteed
							against any interception or other misuse. Any
							information disclosed online is vulnerable to
							interception and by unauthorized parties. Therefore,
							I cannot guarantee complete security if you provide
							personal information.
						</p>
					</section>
					<br />
					<section className="criancas">
						<h3 className="text-uppercase">Children's Policy</h3>
						<p>
							I do not knowingly solicit information from children
							under the age of 13. If you become aware of any data
							that we have collected from children under the age
							of 13, please contact me.
						</p>
					</section>
					<section className="do-not-track">
						<h3 className="text-uppercase">
							Controls for "do-not-track" features
						</h3>
						<p>
							Most web browsers and some mobile operating systems
							include a Do-Not-Track ("DNT") feature or setting
							that you can enable to signal your privacy
							preference not to have data about your online
							browsing activities monitored and collected. No
							uniform technology standard for recognizing and
							implementing implementation of DNT signals has been
							finalized. As as such, I currently do not respond to
							browser signals or to any other mechanism that
							automatically communicates your choice not to be
							tracked online. If a standard for online tracking is
							adopted tracking that I must follow in the future, I
							will inform you inform you of this practice in a
							revised version of this Privacy Policy. Most web
							browsers and some mobile operating systems include a
							Do-Not-Track ("DNT") feature or setting that you can
							enable to signal your privacy preference of not
							having data about your online browsing activities
							monitored and collected. If you set the DNT signal
							in your browser, you will respond to these DNT
							browser signals.
						</p>
					</section>
					<br />
				</Container>
			</section>
		</>
	);
};

export default PrivacyPolicy;
